import React, { useContext /* , useState */ } from 'react';
import PropTypes from 'prop-types';

import btn from 'assets/img/pay-methods/btn.png';
import nequi from 'assets/img/pay-methods/nequi.webp';
import pse from 'assets/img/pay-methods/pse.png';
import efecty from 'assets/img/pay-methods/efecty.png';
import rcb from 'assets/img/pay-methods/rcb.png';
import card from 'assets/img/pay-methods/card.png';

import { Accordion, AccordionContext, Button, Card, Col /* , Image */, Row, useAccordionButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { /* useParams, */ Link } from 'react-router-dom';
import classNames from 'classnames';
/* import { CourseContext } from 'context/Context'; */
/* import useCourses from 'hooks/useCourses'; */
//import playIcon from 'assets/img/icons/play.svg';
import Flex from 'components/common/Flex';
//import Hoverbox from 'components/common/Hoverbox';
import SoftBadge from 'components/common/SoftBadge';
/* import StarRating from 'components/common/StarRating'; */
/* import course1 from 'assets/img/e-learning/courses/course1.png';
import beachVideo from 'assets/video/beach.mp4';
import beachPoster from 'assets/video/beach.jpg'; */
/* import InputImage from './InputImage'; */
import { /* currency, */ numberToWords } from 'helpers/utils';
import Avatar from 'components/common/Avatar';
import FalconLightBox from 'components/common/FalconLightBox';
/* import CardDropdown from 'components/common/CardDropdown'; */
import numeral from 'numeral';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
const state = {
 PENDING: { vr: 'info', icon: 'clock' },
 APPROVED: { vr: 'success', icon: 'check-circle' },
 DECLINED: { vr: 'danger', icon: 'ban' },
 ERROR: { vr: 'danger', icon: 'exclamation-triangle' },
 EXPIRED: { vr: 'warning', icon: 'times-circle' },
 VOIDED: { vr: 'danger', icon: 'ban' }
};
const typePay = {
 RCB: rcb,
 PSE: pse,
 PCOL: btn,
 NEQUI: nequi,
 CARD: card,
 BANCOLOMBIA_QR: null,
 BANCOLOMBIA_COLLECT: efecty,
 BANCOLOMBIA_TRANSFER: btn
};

/* const tags = {
 writing: {
  id: 1,
  type: 'primary',
  content: 'Writing',
  icon: 'pen-nib'
 },
 topTrainer: {
  id: 2,
  type: 'success',
  content: 'Top Trainer',
  icon: 'crown'
 },
 editorsChoice: {
  id: 3,
  type: 'warning',
  content: 'Editor’s Choice',
  icon: 'award'
 },
 misc: {
  id: 4,
  type: 'primary',
  content: 'Misc.',
  icon: 'thumbtack'
 },
 design: {
  id: 5,
  type: 'primary',
  content: 'Design',
  icon: 'brush'
 },
 bestSeller: {
  id: 6,
  type: 'success',
  content: 'Best Seller',
  icon: 'hashtag'
 },
 painting: {
  id: 7,
  type: 'primary',
  content: 'Painting',
  icon: 'palette'
 }
}; */
/* const course = {
 id: 'CN000001',
 name: 'Script Writing Masterclass: Introdution to Industry Cliches',
 price: 69.99,
 oldPrice: 139.99,
 excerpt:
  'Explore all the advanced design tools like Photoshop, Illustrator, Krita, Procreate, & Inkscape; trace the evolution of graphic design with us, from the first breakthrough of image development to today’s AI assisted designs. Begin your visual language journey with these advanced design tools.',
 trainer: 'Bill Finger',
 thumbnail: {
  image: course1,
  video: beachVideo,
  videoPoster: beachPoster
 },
 totalEnrolled: 92632,
 rating: 4.8,
 review: 78259,
 tags: [tags.writing, tags.topTrainer, tags.editorsChoice]
}; */

const CustomToggle = ({ eventKey, className }) => {
 const { activeEventKey } = useContext(AccordionContext);
 const decoratedOnClick = useAccordionButton(eventKey);

 const isCurrentEventKey = activeEventKey === eventKey;
 return (
  <Button
   variant="falcon-primary"
   type="button"
   className={classNames('p-0 mx-3 icon-item icon-item-sm', { [className]: className })}
   onClick={decoratedOnClick}
  >
   <FontAwesomeIcon icon={isCurrentEventKey ? 'chevron-up' : 'chevron-down'} />
  </Button>
 );
};

const Input = ({ product, index, onSubmitStatus }) => {
 /* const { company } = useParams(); */
 const {
  _id,
  id,
  receivers,
  project,
  status,
  amount,
  /* params, */
  created_at,
  payment_method,
  status_message,
  /* type, */
  /* payment_method_type, */
  finalized_at,
  currency
  /* reference, */
  /* redirect_url, */
  /* updatedAt, */
  /* createdAt */
 } = product;

 /* const {
  thumbnail: { video, videoPoster },
  tags
 } = course; */

 return (
  <Card className="mb-2 overflow-hidden">
   <Card.Header className="border-bottom border-200">
    <small className="fs--2 text-800 d-block d-sm-none text-end">{dayjs(created_at).locale('es').format('llll')}</small>
    <Flex justifyContent="start" alignItems="center" wrap="wrap">
     <Avatar size="2xl" src={typePay[payment_method?.type]} name={project?.name} className="me-1" />
     <div className="flex-grow-1 text-truncate">
      <h5 className="mb-0 fs--1 text-capitalize">
       <Link to={`/payments/invoice/${id}`}>{id}</Link>
      </h5>
      <h4 className="m-0 fs--1 text-capitalize">{receivers[0].arrayName.join(' ').toLowerCase()}</h4>
     </div>
     <div className="d-flex justify-content-center justify-content-md-end align-items-center flex-nowrap flex-grow-1 mt-2 mt-md-0">
      <div className="px-3 border-start border-start-2">
       <h5 className="mb-0 fs--1 fs-md--1">{numeral(amount).format('$0,0[.]00')}</h5>
       <p className="mb-0 fs--2 text-center d-none d-sm-block">{dayjs(created_at).locale('es').format('llll')}</p>
      </div>
      <div className="px-3 border-start border-start-2">
       <SoftBadge pill bg={state[status].vr} style={{ width: '100px' }}>
        <FontAwesomeIcon icon={state[status].icon} className="me-1" transform="shrink-4" />
        {status}
       </SoftBadge>
      </div>
      <CustomToggle eventKey={index} className="" />
     </div>
    </Flex>
   </Card.Header>
   <Accordion.Collapse eventKey={index}>
    <Card.Body className="py-0">
     <Flex justifyContent="center" alignItems="center" wrap="nowrap">
      {payment_method?.type === 'RCB' && (
       <FalconLightBox image={payment_method?.image} className="me-3 d-none d-lg-block">
        <Avatar size="5xl" rounded="soft" src={payment_method?.image} name={_id} />
       </FalconLightBox>
      )}

      <div className="py-x1 flex-grow-1">
       <Row className="g-0">
        <Col lg={6} as={Flex} className="flex-column pe-md-x1">
         <Flex justifyContent="end" alignItems="center" className="mb-2">
          <SoftBadge pill bg="primary">
           <FontAwesomeIcon icon="dollar-sign" className="me-1" transform="shrink-4" />
           {currency}
          </SoftBadge>
         </Flex>
         <Flex justifyContent="center" alignItems="center" wrap="nowrap" className="mb-2">
          {payment_method?.type === 'RCB' ? (
           <FalconLightBox image={payment_method?.image} className="me-3 mb-1 d-block d-sm-none">
            <Avatar size="3xl" src={payment_method?.image} name={_id} />
           </FalconLightBox>
          ) : (
           <Avatar
            size="3xl"
            src={typePay[payment_method?.type] || payment_method?.extra?.qr_image}
            name={_id}
            className="me-3 mb-1"
           />
          )}

          <div className="flex-grow-1">
           <div className="pb-2 border-bottom border-200">
            <div className="position-relative ps-3">
             <div className="position-absolute h-100 start-0 rounded bg-primary" style={{ width: '4px' }} />
             {/* {payment_method?.type === 'RCB' ? (
              <>
               <h6 className="fs--2 text-600 mb-1">
                Ref.{' '}
                {payment_method?.ref ||
                 payment_method?.financial_institution_code ||
                 payment_method?.extra?.business_agreement_code ||
                 payment_method?.extra?.external_identifier}
               </h6>
               <Flex alignItems="center">
                <h5 className="text-700 fs-2 me-2">
                 {payment_method?.user_type ||
                  payment_method?.phone_number ||
                  payment_method?.extra?.name ||
                  payment_method?.user_legal_id ||
                  payment_method?.extra?.payment_intention_identifier ||
                  payment_method?.extra?.qr_id?.slice(-4) ||
                  numeral(payment_method?.amount).format('$0,0[.]00')}
                </h5>
                <SoftBadge className="fs--2 fw-medium d-none d-sm-block" bg="success" pill>
                 <FontAwesomeIcon icon="calendar-alt" />{' '}
                 {payment_method?.extra?.card_type ||
                  payment_method?.type ||
                  dayjs(payment_method?.date).locale('es').format('ll')}
                </SoftBadge>
               </Flex>
               <SoftBadge className="fs--2 fw-medium d-block d-sm-none" bg="success" pill>
                <FontAwesomeIcon icon="calendar-alt" /> {dayjs(payment_method?.date).locale('es').format('ll')}
               </SoftBadge>
              </>
             ) : payment_method?.type === 'NEQUI' ? (
              <>
               <h6 className="fs--2 text-600 mb-1">Ref. {payment_method?.extra?.external_identifier}</h6>
               <Flex alignItems="center">
                <h5 className="text-700 fs-2 me-2">{payment_method?.phone_number}</h5>
                <SoftBadge className="fs--2 fw-medium d-none d-sm-block" bg="info" pill>
                 {payment_method?.type}
                </SoftBadge>
               </Flex>
               <SoftBadge className="fs--2 fw-medium d-block d-sm-none" bg="info" pill>
                {payment_method?.type}
               </SoftBadge>
              </>
             ) : payment_method?.type === 'CARD' ? (
              <>
               <h6 className="fs--2 text-600 mb-1">Ref. {payment_method?.extra?.external_identifier}</h6>
               <Flex alignItems="center">
                <h5 className="text-700 fs-2 me-2">{payment_method?.extra?.name}</h5>
                <SoftBadge className="fs--2 fw-medium d-none d-sm-block" bg="info" pill>
                 {payment_method?.extra?.card_type}
                </SoftBadge>
               </Flex>
               <SoftBadge className="fs--2 fw-medium d-block d-sm-none" bg="info" pill>
                {payment_method?.extra?.card_type}
               </SoftBadge>
              </>
             ) : payment_method?.type === 'PSE' ? (
              <>
               <h6 className="fs--2 text-600 mb-1">Ref. {payment_method?.financial_institution_code}</h6>
               <Flex alignItems="center">
                <h5 className="text-700 fs-2 me-2">
                 {payment_method?.user_legal_id_type} - {payment_method?.user_legal_id}
                </h5>
                <SoftBadge className="fs--2 fw-medium d-none d-sm-block" bg="info" pill>
                 {payment_method?.type}
                </SoftBadge>
               </Flex>
               <SoftBadge className="fs--2 fw-medium d-block d-sm-none" bg="info" pill>
                {payment_method?.type}
               </SoftBadge>
              </>
             ) : payment_method?.type === 'BANCOLOMBIA_QR' ? (
              <>
               <h6 className="fs--2 text-600 mb-1">Ref. {payment_method?.extra?.external_identifier}</h6>
               <Flex alignItems="center">
                <h5 className="text-700 fs-2 me-2">{payment_method?.extra?.qr_id.slice(-4)}</h5>
                <SoftBadge className="fs--2 fw-medium d-none d-sm-block" bg="info" pill>
                 {payment_method?.type}
                </SoftBadge>
               </Flex>
               <SoftBadge className="fs--2 fw-medium d-block d-sm-none" bg="info" pill>
                {payment_method?.type}
               </SoftBadge>
              </>
             ) : payment_method?.type === 'BANCOLOMBIA_COLLECT' ? (
              <>
               <h6 className="fs--2 text-600 mb-1">Ref. {payment_method?.extra?.business_agreement_code}</h6>
               <Flex alignItems="center">
                <h5 className="text-700 fs-2 me-2">{payment_method?.extra?.payment_intention_identifier}</h5>
                <SoftBadge className="fs--2 fw-medium d-none d-sm-block" bg="info" pill>
                 {payment_method?.type}
                </SoftBadge>
               </Flex>
               <SoftBadge className="fs--2 fw-medium d-block d-sm-none" bg="info" pill>
                {payment_method?.type}
               </SoftBadge>
              </>
             ) : payment_method?.type === 'BANCOLOMBIA_TRANSFER' ? (
              <>
               <h6 className="fs--2 text-600 mb-1">Ref. {payment_method?.extra?.external_identifier}</h6>
               <Flex alignItems="center">
                <h5 className="text-700 fs-2 me-2">{payment_method?.user_type}</h5>
                <SoftBadge className="fs--2 fw-medium d-none d-sm-block" bg="info" pill>
                 {payment_method?.type}
                </SoftBadge>
               </Flex>
               <SoftBadge className="fs--2 fw-medium d-block d-sm-none" bg="info" pill>
                {payment_method?.type}
               </SoftBadge>
              </>
             ) : (
              <> </>
             )} */}

             <h6 className="fs--2 text-600 mb-1">
              Ref.{' '}
              {payment_method?.ref ||
               payment_method?.financial_institution_code ||
               payment_method?.extra?.business_agreement_code ||
               payment_method?.extra?.external_identifier}
             </h6>
             <Flex alignItems="center">
              <h5 className="text-700 fs-2 me-2">
               {payment_method?.type === 'RCB'
                ? numeral(payment_method?.amount).format('$0,0[.]00')
                : payment_method?.user_type ||
                  payment_method?.phone_number ||
                  payment_method?.extra?.name ||
                  payment_method?.user_legal_id ||
                  payment_method?.extra?.payment_intention_identifier ||
                  payment_method?.extra?.qr_id?.slice(-4)}
              </h5>
              <SoftBadge className="fs--2 fw-medium d-none d-sm-block" bg="success" pill>
               {payment_method?.type === 'RCB' && <FontAwesomeIcon icon="calendar-alt" />}
               {payment_method?.type === 'RCB'
                ? ' ' + dayjs(payment_method?.date).locale('es').format('ll')
                : payment_method?.extra?.card_type || payment_method?.type}
              </SoftBadge>
             </Flex>
             <SoftBadge className="fs--2 fw-medium d-block d-sm-none" bg="success" pill>
              {payment_method?.type === 'RCB' && <FontAwesomeIcon icon="calendar-alt" />}
              {payment_method?.type === 'RCB'
               ? ' ' + dayjs(payment_method?.date).locale('es').format('ll')
               : payment_method?.extra?.card_type || payment_method?.type}
             </SoftBadge>
            </div>
           </div>
          </div>
         </Flex>
         <p className="fs--2 fs-md--1 text-end mb-1">
          {payment_method?.type === 'RCB'
           ? numberToWords(payment_method?.amount) || payment_method?.description
           : payment_method?.type === 'CARD'
           ? 'numero de cuotas en que el pago fue diferido ' + payment_method?.installments
           : payment_method?.payment_description || '...'}
         </p>
         <p className="fs--2 fs-md--1 text-info">{status_message}</p>
         <div className="flex-1 d-flex align-items-end fw-semi-bold fs--2 fs-md--1">
          <span className="me-1 text-900">Aprueba: </span>
          <span className="ms-2 text-secondary d-none d-sm-block">
           {payment_method?.type !== 'RCB' ? 'Wompi' : 'Samyr Saldarriaga Atencio'}
          </span>
         </div>
        </Col>
        <Col lg={6} className="mt-2 mt-lg-0">
         <Flex justifyContent="between" className="h-100 rounded border-lg border-1 flex-lg-column p-lg-3">
          <div className="mb-lg-3 mt-auto mt-lg-0">
           <h4 className="m-0 fs-1 text-warning d-flex">
            <span className="fs-0 text-700">{payment_method?.type}</span>
            <span className="ms-1 fs--2 text-700">{dayjs(finalized_at).locale('es').format('ll')}</span>
            {/* <del className="ms-1 fs--2 text-700">{currency}</del> */}
           </h4>
           <p className="mb-0 fs--2 fs-md--1 text-800">{numberToWords(amount)}</p>
          </div>
          <Flex className="mt-3 flex-lg-column gap-2">
           {payment_method?.type === 'RCB' ? (
            <>
             <div className="white-space-nowrap w-100">
              <Button
               size="sm"
               variant="falcon-default"
               className="fs--1 text-600"
               onClick={() => onSubmitStatus(_id, 'DECLINED')}
              >
               <FontAwesomeIcon icon="ban" />
               <span className="ms-1 d-none d-lg-inline">Declinar</span>
              </Button>
             </div>

             <Button size="sm" variant="success" className="fs--1" onClick={() => onSubmitStatus(_id, 'APPROVED')}>
              <FontAwesomeIcon icon="check" />
              <span className="ms-1 d-none d-lg-inline">Aprobar</span>
             </Button>
            </>
           ) : (
            <></>
           )}
          </Flex>
         </Flex>
        </Col>
       </Row>
      </div>
     </Flex>
    </Card.Body>
   </Accordion.Collapse>
  </Card>
 );
};

Input.propTypes = {
 product: PropTypes.object.isRequired,
 index: PropTypes.number.isRequired,
 onSubmitStatus: PropTypes.func.isRequired
 //  product: PropTypes.shape({
 /* _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  typeProducts: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  receivers: PropTypes.array.isRequired,
  products: PropTypes.array.isRequired,
  project: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  created_at: PropTypes.string.isRequired */
 /* name: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired, */
 /* images: PropTypes.arrayOf(
   PropTypes.shape({
    image: PropTypes.string.isRequired,
    video: PropTypes.string.isRequired,
    videoPoster: PropTypes.string.isRequired
   })
  ).isRequired, */
 /* status: PropTypes.string.isRequired,
  financings: PropTypes.arrayOf(
   PropTypes.shape({
    minInitialPay: PropTypes.number.isRequired,
    maxFinancing: PropTypes.number.isRequired
   })
  ).isRequired,
  qualities: PropTypes.arrayOf(
   PropTypes.shape({
    value: PropTypes.string.isRequired
   })
  ).isRequired,
  shortDescription: PropTypes.string.isRequired,
  stock: PropTypes.number.isRequired */
 //  }).isRequired,
};

CustomToggle.propTypes = {
 eventKey: PropTypes.number.isRequired,
 className: PropTypes.string
};

export default Input;
